import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchLoginForm } from "../../services/user/LoginService";


export const fetchLoginFormAsync = createAsyncThunk(
  "user/fetchApplicationDetails",
  async (appId: any, thunkAPI) => {
    const response = await fetchLoginForm(appId);
    return response;
  }
);